import { SimulationClock } from "./simulation-clock.js";

export class ClockDisp extends SimulationClock {
  static instance = null;
  static lastLevelCompleted = 0;

  static getInstance() {
    if (!ClockDisp.instance) {
      ClockDisp.instance = new ClockDisp();
    }
    return ClockDisp.instance;
  }

  static applyFilters(element, color = 0) {
    element.style.textShadow = [
      `0 0 1px rgb(${color >> 16 & 255} ${color >> 8 & 255} ${color & 255})`,
      `0 0 2px rgb(${color >> 16 & 255} ${color >> 8 & 255} ${color & 255})`,
      `0 0 3px rgb(${color >> 16 & 255} ${color >> 8 & 255} ${color & 255})`,
    ].join(", ");
  }

  constructor() {
    super();
    this.listeners = new Map();

    this.element = document.createElement("div");
    this.element.style.position = "absolute";
    this.element.style.left = "0";
    this.element.style.top = "0";
    this.element.style.color = "#fff";
    this.element.style.fontFamily = "Consolas, monospace";
    this.element.style.fontSize = "17px";
    this.element.style.fontWeight = "700";
    this.element.style.userSelect = "none";
    this.element.style.whiteSpace = "pre";

    ClockDisp.applyFilters(this.element, 0);
    this.reset();
  }

  attach(parent, x, y) {
    this.setPosition(x, y);
    if (this.element.parentElement) {
      this.element.parentElement.removeChild(this.element);
    }
    parent.appendChild(this.element);
  }

  addEventListener(type, handler) {
    if (!this.listeners.has(type)) {
      this.listeners.set(type, new Set());
    }
    this.listeners.get(type).add(handler);
  }

  dispatchEvent(type) {
    for (const handler of this.listeners.get(type) ?? []) {
      handler({ type, target: this });
    }
  }

  update() {
    super.update();
    if (this.freezeFrames === 0) {
      this.element.textContent = this.textContent;
      return;
    }
    if (this.freezeFrames === 0) {
      this.dispatchEvent("Counter");
    }
  }

  setPosition(x, y) {
    this.element.style.left = `${x}px`;
    this.element.style.top = `${y}px`;
  }

  setFont(font) {
    this.element.style.fontFamily = font;
  }

  setSize(size) {
    this.element.style.fontSize = `${size}px`;
  }

  show() {
    this.element.style.display = "";
  }

  hide() {
    this.element.style.display = "none";
  }

  reset() {
    super.reset();
    this.element.textContent = this.textContent;
  }

  setState(state) {
    super.setState(state);
    this.element.textContent = this.textContent;
  }

  setText(text) {
    this.textTemplate = text;
    this.element.textContent = this.textContent;
  }
}
